const api_root = process.env.REACT_APP_API_ROOT || 'https://app.mapgeoid.com';
export const project_api_path = `${api_root}/api-service/projects`;
export const layer_api_path = `${api_root}/api-service/layers`;
export const add_layer_to_panel_url = `${api_root}/api-service/layers`;
export const remove_layer_from_panel_url = `${api_root}/api-service/layers`;
export const user_login_url = `${api_root}/api-service/auth/login`;
export const feature_service_url = `${api_root}/api-service/feature_service/get_features`;
export const routing_service_url = `${api_root}/api-service/routing/optimized_route`;
export const get_tickets_url = `${api_root}/api-service/ticket-management/tickets`;
export const create_ticket_url = `${api_root}/api-service/ticket-management/create-survey-ticket`;
export const project_dropdown_url = `${api_root}/api-service/dynamic-dropdown/projects`;
export const layer_dropdown_url = `${api_root}/api-service/dynamic-dropdown/layers`;
export const user_dropdown_url = `${api_root}/api-service/dynamic-dropdown/users`;
export const ticket_dropdown_url = `${api_root}/api-service/dynamic-dropdown/tickets`;
export const logout_url = `${api_root}/api-service/auth/logout`;
export const video_streaming_url = `${api_root}/api-service/video-streaming`;


